// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template {
  margin: 10px 10px 10px 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
  display: block;
  position: relative;
  align-items: stretch;
  min-height: 100px;
}
.template .border {
  border-bottom: 1px solid #e3e2df;
}
.template .border p {
  margin-bottom: 10px;
  margin-left: 15px;
}
.template .border li {
  list-style-type: none;
}

a {
  color: #000;
}
a span {
  color: #606060;
}

h2 {
  margin-bottom: 20px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 20px;
  margin-left: 20px;
}
.row .col-sm {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.row .col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.align {
  float: right;
}

.active {
  color: #FF4612;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZhcS5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLDJCQUFBO0VBQ0EsYUFBQTtFQUNBLHNCQUFBO0VBQ0EsbUJBQUE7RUFDQSxjQUFBO0VBQ0Esa0JBQUE7RUFDQSxvQkFBQTtFQUNBLGlCQUFBO0FBQ0Y7QUFDRTtFQUNFLGdDQUFBO0FBQ0o7QUFDSTtFQUNFLG1CQUFBO0VBQ0EsaUJBQUE7QUFDTjtBQUVJO0VBQ0UscUJBQUE7QUFBTjs7QUFLQTtFQUNFLFdBQUE7QUFGRjtBQUdFO0VBQ0UsY0FBQTtBQURKOztBQUtBO0VBQ0UsbUJBQUE7QUFGRjs7QUFLQTtFQUNFLGFBQUE7RUFDQSxlQUFBO0VBQ0Esa0JBQUE7RUFDQSxpQkFBQTtBQUZGO0FBSUE7RUFDRSxhQUFBO0VBR0UsWUFBQTtFQUNBLGVBQUE7QUFGSjtBQUtBO0VBR0UsYUFBQTtFQUNBLGNBQUE7QUFIRjs7QUFPQTtFQUNFLFlBQUE7QUFKRjs7QUFPQTtFQUNFLGNBQUE7QUFKRiIsImZpbGUiOiJmYXEuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudGVtcGxhdGUge1xuICBtYXJnaW46IDEwcHggMTBweCAxMHB4IDEwcHg7XG4gIHBhZGRpbmc6IDIwcHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmY7XG4gIGJvcmRlci1yYWRpdXM6IDE1cHg7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGFsaWduLWl0ZW1zOiBzdHJldGNoO1xuICBtaW4taGVpZ2h0OiAxMDBweDtcblxuICAuYm9yZGVye1xuICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZTNlMmRmO1xuXG4gICAgcHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDEwcHg7XG4gICAgICBtYXJnaW4tbGVmdDogMTVweDtcbiAgICB9XG5cbiAgICBsaSB7XG4gICAgICBsaXN0LXN0eWxlLXR5cGU6IG5vbmU7XG4gIH1cbiAgfVxufVxuXG5he1xuICBjb2xvcjogIzAwMDtcbiAgc3BhbiB7XG4gICAgY29sb3I6ICM2MDYwNjA7XG4gIH1cbn1cblxuaDJ7XG4gIG1hcmdpbi1ib3R0b206IDIwcHg7XG59XG5cbi5yb3d7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgbWFyZ2luLXJpZ2h0OiAyMHB4O1xuICBtYXJnaW4tbGVmdDogMjBweDtcblxuLmNvbC1zbXtcbiAgZmxleC1iYXNpczogMDtcbiAgICAtd2Via2l0LWJveC1mbGV4OiAxO1xuICAgIC1tcy1mbGV4LXBvc2l0aXZlOiAxO1xuICAgIGZsZXgtZ3JvdzogMTtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG59XG5cbi5jb2wtNntcbiAgLXdlYmtpdC1ib3gtZmxleDogMDtcbiAgLW1zLWZsZXg6IDAgMCA1MCU7XG4gIGZsZXg6IDAgMCA1MCU7XG4gIG1heC13aWR0aDogNTAlO1xufVxufVxuXG4uYWxpZ257XG4gIGZsb2F0OiByaWdodDtcbn1cblxuLmFjdGl2ZXtcbiAgY29sb3I6ICNGRjQ2MTI7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/containers/static-resources/FAQ/faq.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;AACF;AACE;EACE,gCAAA;AACJ;AACI;EACE,mBAAA;EACA,iBAAA;AACN;AAEI;EACE,qBAAA;AAAN;;AAKA;EACE,WAAA;AAFF;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAFF;AAIA;EACE,aAAA;EAGE,YAAA;EACA,eAAA;AAFJ;AAKA;EAGE,aAAA;EACA,cAAA;AAHF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,cAAA;AAJF;AAHA,o2DAAo2D","sourcesContent":[".template {\n  margin: 10px 10px 10px 10px;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 15px;\n  display: block;\n  position: relative;\n  align-items: stretch;\n  min-height: 100px;\n\n  .border{\n    border-bottom: 1px solid #e3e2df;\n\n    p{\n      margin-bottom: 10px;\n      margin-left: 15px;\n    }\n\n    li {\n      list-style-type: none;\n  }\n  }\n}\n\na{\n  color: #000;\n  span {\n    color: #606060;\n  }\n}\n\nh2{\n  margin-bottom: 20px;\n}\n\n.row{\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: 20px;\n  margin-left: 20px;\n\n.col-sm{\n  flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n}\n\n.col-6{\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n}\n\n.align{\n  float: right;\n}\n\n.active{\n  color: #FF4612;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
